define(function (require, exports, module) {
    'use strict';

    var UploadReason = require('../UploadReason');

    /**
     * @constructor
     * @extends {UploadReason}
     * @param {Error} stack
     * @param {string} source
     */
    function UploadError(stack, source) {
        if (!(this instanceof UploadError)) {
            throw new TypeError(UploadError.ERROR_WRONG_INSTANCE);
        }

        if (this.constructor === UploadError) {
            throw new TypeError(UploadError.ERROR_ABSTRACT_CLASS);
        }

        UploadReason.apply(this, arguments);
    }

    UploadError.ERROR_WRONG_INSTANCE = 'UploadError called on non-instance of UploadError';
    UploadError.ERROR_ABSTRACT_CLASS = 'UploadError is abstract class';

    UploadError.prototype = Object.assign(Object.create(UploadReason.prototype), {
        constructor: UploadError,
        className: 'UploadError',
        radarName: 'error_{SOURCE}_abstract',
    });

    module.exports = UploadError;
});
